import { FORECAST_STATUS, FORECAST_WINDOW_STATUS } from "@/components/forecasts/constants";
import { moment as momentUtils } from "@/utils/moment";
import * as moment from "moment/moment";

export function formatDate(date, format = "DD/MM/YYYY") {
    if (!date) {
        return "";
    }

    // Si date n'est ni un objet Date ni un object Moment, on renvoie un string vide ""
    if (!(date instanceof Date) && !moment.isMoment(date)) {
        return "";
    }

    return momentUtils(date).format(format);
}

// Retourne la date au format 'JJ Mois. YYYY'
// Ex : '01st Jan. 2022'
export function formatDateOrdinal(date) {
    if (!(date instanceof Date)) {
        return "";
    }

    // Conversion en objet moment pour éviter les problèmes de fuseaux horaires
    date = momentUtils(date);

    const da = date.format("DD"); // Numéro du jour               27
    const mo = date.format("MMM"); // Début du mois en lettres    Aug
    const ye = date.format("YYYY"); // Année complète             2022
    // En voir plus https://momentjs.com/docs/#/displaying/

    return `${da}${getOrdinalSuffix(da)} ${mo}. ${ye}`;
}

function getOrdinalSuffix(number) {
    if (number % 10 === 1 && number === 11) return "st";
    if (number % 10 === 2 && number === 12) return "nd";
    if (number % 10 === 3 && number === 13) return "rd";
    return "th";
}

export function getStatusColor(status) {
    if (status === "DELETE") {
        return "#d6d6d6";
    } else if (status === FORECAST_STATUS.DRAFT) {
        return "#57A1D3";
    } else if (status === FORECAST_STATUS.PENDING) {
        return "#FA824C";
    } else if (status === FORECAST_STATUS.ACTIVE) {
        return "#9EC92B";
    } else if (status === FORECAST_STATUS.CLOSED) {
        return "#4F4754";
    }
    // return black as default color;
    return "f000";
}

export function getStatusBgColor(status) {
    if (status === "DELETE") {
        return "#f8f8f8";
    } else if (status === FORECAST_STATUS.DRAFT) {
        return "#e6f2f9";
    } else if (status === FORECAST_STATUS.PENDING) {
        return "#fdefe8";
    } else if (status === FORECAST_STATUS.ACTIVE) {
        return "#f3f7e8";
    } else if (status === FORECAST_STATUS.CLOSED) {
        return "#eaeaeb";
    }
    // return black as default color;
    return "#FFFFFF";
}

export function getStatusLetter(status) {
    if (status === FORECAST_STATUS.DRAFT) {
        return "D";
    } else if (status === FORECAST_STATUS.PENDING) {
        return "P";
    } else if (status === FORECAST_STATUS.ACTIVE) {
        return "A";
    } else if (status === FORECAST_STATUS.CLOSED) {
        return "C";
    }
    return status;
}

export function getStatusName(status) {
    if (status === "DELETE") {
        return "cancelled";
    } else if (status === FORECAST_STATUS.DRAFT) {
        return "draft";
    } else if (status === FORECAST_STATUS.PENDING) {
        return "pending";
    } else if (status === FORECAST_STATUS.ACTIVE) {
        return "active";
    } else if (status === FORECAST_STATUS.CLOSED) {
        return "closed";
    }
    return status;
}

export function getStatusNameWindow(status) {
    if (status === "DELETE") {
        return "cancelled";
    } else if (status === FORECAST_WINDOW_STATUS.DRAFT) {
        return "draft";
    } else if (status === FORECAST_WINDOW_STATUS.SUBMITTED) {
        return "submitted";
    } else if (status === FORECAST_WINDOW_STATUS.RE_CHALLENGED) {
        return "re-challenged";
    } else if (status === FORECAST_WINDOW_STATUS.SAVED) {
        return "saved";
    }
    return "";
}

export const FORECAST_WINDOW_COLORS = Object.freeze({ RE_CHALLENGED: "#fac625", VALIDATED: "#85c627", SUBMITTED: "#52b4e8" });

/**
 *
 * @param dateString
 * @returns {null|Date}
 */
export function parseDate(dateString) {
    if (dateString === null) {
        return null;
    }
    try {
        return momentUtils(dateString).toDate();
    } catch (e) {
        return null;
    }
}

export function getQuantitiesForForecastWindow(itemId, forecastWindow) {
    return forecastWindow.quantities.filter(q => q.item === itemId).reduce((a, b) => a + b.quantity, 0);
}

export function getQuantitiesForForecastWindows(itemId, forecastWindows) {
    return forecastWindows.reduce((prev, curr) => prev + getQuantitiesForForecastWindow(itemId, curr), 0);
}



// WEBPACK FOOTER //
// ./src/components/forecasts/utils/utilis.js